<script>
export default {
  name: "eo-colors-mixin",
  computed: {
    textColor() {
      return this.$store.state.textColor;
    },
    accentColor() {
      return this.$vuetify.theme.currentTheme.accent;
    }
  }
};
</script>
